import React from 'react';
import { Spin } from 'antd';

const LoadingWithSpin = ({ children, visible = false }) => {
  if (visible) {
    return <Spin tip="Atualizando...">{children}</Spin>;
  }

  return children;
};

export default LoadingWithSpin;
